

export const RECEIPTS_PAYSLIP_ACTION = "RECEIPTS_PAYSLIP_ACTION";
export const RECEIPTS_PAYSLIP_SUCCESS = "RECEIPTS_PAYSLIP_SUCCESS";
export const RECEIPTS_PAYSLIP_FAIL = "RECEIPTS_PAYSLIP_FAIL";

export const CASH_FLOW_GET_TRANSACTION_ACTION = "CASH_FLOW_GET_TRANSACTION_ACTION";
export const CASH_FLOW_GET_TRANSACTION_SUCCESS = "CASH_FLOW_GET_TRANSACTION_SUCCESS";

export const CASH_FLOW_GET_ACCOUNT_ACTION = "CASH_FLOW_GET_ACCOUNT_ACTION";
export const CASH_FLOW_GET_ACCOUNT_SUCCESS = "CASH_FLOW_GET_ACCOUNT_SUCCESS";

export const CASH_FLOW_GET_TRANSACTION_IMBALANCE_ACTION = "CASH_FLOW_GET_TRANSACTION_IMBALANCE_ACTION";
export const CASH_FLOW_GET_TRANSACTION_IMBALANCE_SUCCESS = "CASH_FLOW_GET_TRANSACTION_IMBALANCE_SUCCESS";
